import { formatMoney, formatPennies } from '../services';

export interface MoneyMixins {
  formatPennies(amount: number, currency: string): string;
  formatMoney(amount: number, currency: string): string;
}

export const moneyMixins: MoneyMixins = {
  formatPennies(amount, currency) {
    return formatPennies(amount, currency);
  },
  formatMoney(amount, currency) {
    return formatMoney(amount, currency);
  },
};
